import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contentValues: [],
  loading: true,
  error: null,
};

const contentSlices = createSlice({
  name: "contents",
  initialState,

  reducers: {
    getContentStart(state) {
      state.loading = true;
      state.error = null;
    },
    getContentValues(state, action) {
      state.loading = false;
      state.contentValues = action.payload;
    },
    getContentFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { getContentFailure, getContentStart, getContentValues } =
  contentSlices.actions;

export default contentSlices.reducer;
